import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment/moment";
// const leftPanel = "/images/Sticker_black.png";
const bottomPanel = "/images/sticker.jpeg";
const smallCountPerpage = 14;

export const generateQRPDF = async (allData, settingList, size) => {
  try {
    const pdfDoc = new jsPDF({
      orientation: "l", // Landscape
      unit: "pt", // Points
      format: [594.72, 419.04], // Custom dimensions in points
      compress: true,
    });

    pdfDoc.setFont("helvetica", "bold");

    const pageWidth = pdfDoc.internal.pageSize.width;
    const pageHeight = pdfDoc.internal.pageSize.height;
    const margin = 20; // Margin around the table
    const tableWidth = pageWidth - 2 * margin; // Fit table within page width
    const tableHeight = pageHeight - 2 * margin; // Fit table within page height
    // const fontSize = size === "large" ? 8 : size === "medium" ? 6 : 4;
    const cellPadding = { top: 3, left: 5, bottom: 3, right: 5 };
    const fontSize = 21;

    const leftPanelWidth = 50; // Adjust the left panel image width dynamically
    const initialYPosition = margin; // Starting position on each page
    const marginHorizontal = (pageWidth - tableWidth) / 2;

    for (let i = 0; i < allData.length; i++) {
      const currentData = allData[i];

      const tableRows = [
        [
          {
            content: "",
            colSpan: 2, // Image spans across 3 columns
            rowSpan: 1,
            styles: { halign: "center", valign: "middle" },
          },
        ],
        [
          // {
          //   content: "",
          //   colSpan: 1,
          //   rowSpan: 5, // rowspan 5 for the image
          //   styles: { halign: "center", valign: "middle", minCellWidth: 30 },
          // },
          {
            content: "Equipment",
            styles: { fontStyle: "bold", halign: "left", valign: "middle" },
          },
          {
            content: currentData?.datasheet_requestedname
              ? currentData?.datasheet_requestedname
              : currentData?.inst_instrumentName,
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Sl.No./ID No.",
            styles: { fontStyle: "bold", halign: "left", valign: "middle" },
          },
          {
            content:
              `${
                currentData.srfInstruments_serialNumber &&
                currentData.certificate_DUCID
                  ? `${currentData.srfInstruments_serialNumber} / ${currentData.certificate_DUCID}`
                  : `${currentData.srfInstruments_serialNumber || ""} || ${
                      currentData.certificate_DUCID || ""
                    }`
              }` || "",
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Certificate No.",
            styles: { fontStyle: "bold", halign: "left", valign: "middle" },
          },
          {
            content:
              `${currentData.certificate_certificateNumber}${
                settingList["amendment"] === "true" &&
                currentData.datasheet_revisionNumber > 0
                  ? `/AMD-${currentData.datasheet_revisionNumber}`
                  : ""
              }` || "",
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Cal. Date",
            styles: { fontStyle: "bold", halign: "left", valign: "middle" },
          },
          {
            content: currentData.certificate_calibrationDate
              ? moment(currentData.certificate_calibrationDate).format(
                  "DD-MM-YYYY"
                )
              : "",
            styles: { halign: "left", valign: "middle" },
          },
        ],
        [
          {
            content: "Due Date",
            styles: { fontStyle: "bold", halign: "left", valign: "middle" },
          },
          {
            content: currentData.certificate_nextDueDate
              ? moment(currentData.certificate_nextDueDate).format("DD-MM-YYYY")
              : "",
            styles: { halign: "left", valign: "middle" },
          },
        ],

        // [
        //   {
        //     content: "",
        //     colSpan: 3, // Image spans across 3 columns
        //     rowSpan: 1,
        //     styles: { halign: "center", valign: "middle" },
        //   },
        // ],
      ];

      autoTable(pdfDoc, {
        startY: initialYPosition,
        body: tableRows,
        theme: "grid",
        styles: {
          font: "helvetica",
          fontSize,
          fillColor: false,
          textColor: [0, 0, 0],
          lineColor: [0, 0, 0],
          lineWidth: 1.5,
          cellPadding,
          minCellHeight: tableHeight / tableRows.length,
        },
        margin: {
          top: 10,
          left: marginHorizontal,
          bottom: 10,
          right: marginHorizontal,
        },
        tableWidth,
        didDrawCell: (data) => {
          const { section } = data;
          if (section === "body") {
            const cell = data.cell;
            const rowIndex = data.row.index;
            const columnIndex = data.column.index;

            // if (columnIndex === 0 && rowIndex < 5) {
            //   const imgSrc = leftPanel;
            //   // const imgWidth = cell.width -5;
            //   // const imgHeight = cell.height -10;
            //   // const x = cell.x + (cell.width - imgWidth) / 2;
            //   // const y = cell.y +5;
            //   const imgWidth = cell.width -20;
            //   const imgHeight = cell.height -110;
            //   const x = cell.x + (cell.width - imgWidth) / 2;
            //   const y = cell.y +80;

            //   // Add the image to the PDF
            //   pdfDoc.addImage(imgSrc, "PNG", x, y, imgWidth, imgHeight);
            // }

            // Check if this is the last row with bottomPanel image
            if (rowIndex === 0 && columnIndex === 0) {
              const imgSrc = bottomPanel;
              const imgWidth = cell.width;
              const imgHeight = cell.height;
              const x = cell.x + (cell.width - imgWidth) / 2;
              const y = cell.y;

              // Add the bottomPanel image to the PDF
              pdfDoc.addImage(imgSrc, "JPEG", x, y, imgWidth, imgHeight);

              pdfDoc.setLineWidth(0.1);
              pdfDoc.setDrawColor(0, 0, 0);
              pdfDoc.rect(x, y, imgWidth, imgHeight);
            }
          }
        },
        columnStyles: {
          // 0: { cellWidth: (23 / 100) * tableWidth },
          0: { cellWidth: (35 / 100) * tableWidth },
          1: { cellWidth: (65 / 100) * tableWidth },
        },
      });

      // Add new page for the next table
      if (i < allData.length - 1) {
        pdfDoc.addPage();
      }
    }

    // Save or download the PDF
    pdfDoc.save("sticker.pdf");
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};